import React from "react";
import Multimedia from "@sharedComponents/multimedia";

import bannerImage from "@assets/images/dummy-store-merch-banner.png";
import bannerHeadingImage from "@assets/images/banner-heading-text.png";
import styles from "./main.module.scss";

const swagHighlights = [
  "Create custom swag by uploading your logo.",
  "Add swag collections to your shop.",
  "Explore our catalog featuring top brands like The North Face and Carhartt.",
];

const DummyStoreMerchBanner = () => {
  return (
    <section
      className={styles.dummyStoreMerchBanner}
      aria-labelledby="title"
      aria-describedby="description"
    >
      <div className={styles.dummyStoreMerchBannerContent}>
        <div className={styles.dummyStoreMerchHeader} id="title">
          <span className={styles.dummyStoreMerchBannerTitle}>Add Branded Swag</span>
          <Multimedia
            type="image"
            src={bannerHeadingImage}
            width={41}
            height={41}
            alt=""
            aria-hidden="true"
            role="presentation"
            className={styles.dummyStoreMerchBannerHeadingImage}
          />
        </div>
        <p className={styles.dummyStoreMerchBannerSubtitle} id="description">
          Once you save your shop, add swag to make your brand shine.
        </p>
        <ul className={styles.dummyStoreMerchBannerList}>
          {swagHighlights.map((item) => (
            <li key={item} className={styles.dummyStoreMerchBannerListItem}>
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.bannerWrapper}>
        <Multimedia
          type="image"
          src={bannerImage}
          alt="Branded swag preview"
          className={styles.dummyStoreMerchBannerImage}
        />
      </div>
    </section>
  );
};

export default DummyStoreMerchBanner;
